import React from 'react';
import ReactApexChart from 'react-apexcharts';

const NewUserChart = (props) => {
  const state = {
    series: [
      {
        name: 'New Users',
        data: props?.data?.week_wise_counts || [5, 20, 10, 25, 30, 15, 10],
      },
    ],
    options: {
      chart: {
        height: 160,
        type: 'area',
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      stroke: {
        curve: 'smooth',
        width: 3,
        colors: ['#f4543a'],
      },
      colors: ['#f4543a'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 90, 100],
          colorStops: [
            {
              offset: 0,
              color: '#b94feb',
            },
            {
              offset: 100,
              color: '#f4543a',
            },
          ],
        },
      },
      grid: {
        show: true,
        borderColor: '#F2ECEC',
        strokeDashArray: 10,
        yaxis: { lines: { show: true } },
        xaxis: { lines: { show: false } },
      },
      xaxis: {
        categories: props?.data?.day || ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        labels: {
          style: {
            colors: '#666666',
            fontSize: '14px',
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
        tooltip: { enabled: true },
      },
      yaxis: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      tooltip: {
        enabled: true,
        theme: 'light',
        marker: { show: false },
        y: {
          formatter: function (val) {
            return val + ' users';
          },
          title: {
            formatter: () => '',
          },
        },
      },
    },
  };

  return (
    <div className='react-chart p-2 py-0'>
      <ReactApexChart options={state.options} series={state.series} type='area' height={160} />
    </div>
  );
};

export default NewUserChart;
